import {
  SIDEBAR_LINKS_CONSUMPTION,
  SIDEBAR_LINKS_INGESTION,
  SIDEBAR_LINKS_MANAGEMENT,
} from "components/constants";
import { getPermissibleFeatures } from "utils/roleBasedAccess";

const featuresReducer = (state, { type, payload }) => {
  switch (type) {
    case "SET_FEATURES":
      return {
        all: payload?.features,
        permissible: {
          consumption: getPermissibleFeatures({
            links: SIDEBAR_LINKS_CONSUMPTION,
            app: "data_consumption",
            features: payload?.features?.client_apps,
            user: payload?.user,
          }),
          management: getPermissibleFeatures({
            links: SIDEBAR_LINKS_MANAGEMENT,
            app: "data_management",
            features: payload?.features?.client_apps,
            user: payload?.user,
          }),
          ingestion: getPermissibleFeatures({
            links: SIDEBAR_LINKS_INGESTION,
            app: "data_ingestion",
            features: payload?.features?.client_apps,
            user: payload?.user,
          }),
        },
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
};

export default featuresReducer;
